var existClass = function existClass(classString, includeString) {
  var classExist = document.getElementsByClassName(classString)[0];

  if (classExist) {
    return classExist.classList.contains(includeString);
  }
};

export default existClass;